/* ============================================================
   COMPOUND — theme.js  (vanilla, dependency-free)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  const drawer = document.querySelector('[data-drawer]');
  document.querySelectorAll('[data-drawer-open]').forEach((b) =>
    b.addEventListener('click', () => {
      if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    })
  );
  document.querySelectorAll('[data-drawer-close]').forEach((b) =>
    b.addEventListener('click', () => {
      if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
    })
  );

  /* ---------- Sticky header: hide on scroll down ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > 240 && y > last) header.style.transform = 'translateY(-100%)';
      else header.style.transform = 'translateY(0)';
      last = y;
    }, { passive: true });
  }

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  const mainImg = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.full;
      if (mainImg && src) mainImg.src = src;
      document.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.setAttribute('aria-current', 'false'));
      thumb.setAttribute('aria-current', 'true');
    });
  });

  /* ---------- Variant selection ---------- */
  const form = document.querySelector('[data-product-form]');
  if (form && window.__compoundVariants) {
    const variants = window.__compoundVariants;
    const selected = {};
    document.querySelectorAll('[data-option-index]').forEach((group) => {
      const idx = group.dataset.optionIndex;
      const current = group.querySelector('[aria-checked="true"]');
      if (current) selected[idx] = current.dataset.value;
      group.querySelectorAll('[data-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          group.querySelectorAll('[data-value]').forEach((b) => b.setAttribute('aria-checked', 'false'));
          btn.setAttribute('aria-checked', 'true');
          selected[idx] = btn.dataset.value;
          updateVariant();
        });
      });
    });

    function updateVariant() {
      const match = variants.find((v) =>
        v.options.every((opt, i) => String(selected[i]) === String(opt))
      );
      const idInput = form.querySelector('[name="id"]');
      const priceEl = document.querySelector('[data-product-price]');
      const btn = form.querySelector('[data-add]');
      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl && match.priceFmt) priceEl.querySelector('[data-price-current]').textContent = match.priceFmt;
        if (btn) {
          btn.disabled = !match.available;
          btn.querySelector('[data-add-label]').textContent = match.available ? btn.dataset.labelAdd : btn.dataset.labelSold;
        }
      } else if (btn) {
        btn.disabled = true;
        btn.querySelector('[data-add-label]').textContent = btn.dataset.labelUnavailable || 'Unavailable';
      }
    }
  }

  /* ---------- AJAX add to cart + count refresh ---------- */
  async function refreshCount() {
    try {
      const r = await fetch('/cart.js');
      const cart = await r.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (e) { /* noop */ }
  }
  refreshCount();

  document.querySelectorAll('[data-product-form]').forEach((f) => {
    f.addEventListener('submit', async (e) => {
      // Allow graceful fallback if fetch unsupported
      if (!window.fetch) return;
      e.preventDefault();
      const btn = f.querySelector('[data-add]');
      const label = btn?.querySelector('[data-add-label]');
      const original = label?.textContent;
      if (label) label.textContent = 'Adding…';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: f.querySelector('[name="id"]').value,
            quantity: parseInt(f.querySelector('[name="quantity"]')?.value || '1', 10),
          }),
        });
        if (!res.ok) throw new Error('add failed');
        await refreshCount();
        if (label) label.textContent = 'Added ✓';
        setTimeout(() => { if (label) label.textContent = original; }, 1600);
      } catch (err) {
        if (label) label.textContent = original;
        f.submit();
      }
    });
  });
})();
